import { ROUTES } from '@/shared/constants/routes';

export const ONBOARDING_STEPS = [
  'workspaceDetails',
  'createProject',
  'connectSource',
  'exploreTables',
  'createGold',
] as const;

export interface OnboardingProgressSignals {
  readonly hasConnectedSource: boolean;
  readonly hasExploredTable: boolean;
}

export interface OnboardingStepChange {
  readonly kind: 'set' | 'advance';
  readonly index: number;
}

export function onboardingStepChange(
  pathname: string,
  { hasConnectedSource, hasExploredTable }: OnboardingProgressSignals,
): OnboardingStepChange | null {
  if (pathname === ROUTES.WORKSPACES) return { kind: 'set', index: 0 };
  if (pathname === ROUTES.PROJECTS) return { kind: 'set', index: 1 };
  if (pathname === ROUTES.DATASET) return { kind: 'advance', index: hasConnectedSource ? 3 : 2 };
  if (pathname !== ROUTES.DATA_STUDIO) return null;
  if (hasExploredTable) return { kind: 'advance', index: 4 };
  return hasConnectedSource ? { kind: 'advance', index: 3 } : null;
}
